import React, {useState} from 'react';
import {Collapse, Typography, Input, Divider} from 'antd';
import {ProTable} from "@ant-design/pro-components";
import {connect} from "react-redux";
import {SearchOutlined} from "@ant-design/icons";
import {getBranchLabel, getNameFromAction} from "../Actions/utils/functions";
import {helpersDoc} from "./helpers";
import {codeHelpersDoc} from "./codeHelpers";

const { Panel } = Collapse;
const { Text } = Typography;

// `isCode`: o campo é avaliado como JavaScript pelo executor, não pelo
// Handlebars. Os auxiliares `{{ }}` entrariam como texto literal, então no
// lugar deles entra o catálogo de expressões de codeHelpers.js.
const SnippetSections = ({actions, actionStep, trigger, snippets,insertSnippetHelper,insertSnippets,insertCodeHelper, isCode = false,acceptEntryLoop = true}) => {
    const {data} = snippets;
    const [search, setSearch] = useState("");

    // `step` é o índice 0-based do passo (getNameToSnippets soma 1 para montar
    // `steps.N`) e `action` é o passo correspondente — os dois têm de andar
    // juntos, porque getNameToSnippets tira o número de um e o nome customizado
    // do outro.
    const renderTable = (data,step,action = null) => (
        <ProTable
            columns={[
                { title: 'Campo', dataIndex: 'field', key: 'field' },
                { title: 'Tipo', dataIndex: 'type', key: 'type', align: 'right' },
            ]}
            onRow={(record) => {
                return {
                    style: { cursor: 'pointer' },
                    onDoubleClick: () => handleDoubleClick(record,'action',step,action),
                    onClick: () => handleDoubleClick(record,'action',step,action),
                };
            }}
            dataSource={data}
            rowKey="key"
            pagination={false}
            search={false}
            options={false}
            toolBarRender={false}
        />
    );

    function handleDoubleClick(record,type="action",step = null,action = null) {

        if(type === "helper") {
            insertSnippetHelper(record.field, record)
        }else{
            // O registro inteiro segue junto: é dele que sai o tipo do campo,
            // que decide se a anotação precisa do caminho até o `value`.
            if(!!record.propFromLoop){
                insertSnippets(record.field, action,step,true,record)
            }else{
                insertSnippets(record.field, action,step,false,record)
            }

        }
    }

    const renderTableHelpers = (data) => {
        data = data.map(([key,value]) =>{
            value.field = key
            return value;
        })
        return (

            <ProTable
                columns={[
                    {
                        title: 'Nome',
                        dataIndex: 'field',
                        key: 'field'
                    },
                    {
                        title: 'Descricão',
                        dataIndex: 'description',
                        key: 'description',
                        render: (text) => <div dangerouslySetInnerHTML={{__html: text}}></div>
                    },
                    {
                        title: 'Exemplo',
                        dataIndex: 'example',
                        key: 'example',
                        render: (text) => <Text code>{text}</Text>
                    },
                ]}
                dataSource={data}
                onRow={(record) => {
                    return {
                        style: { cursor: 'pointer' },
                        onDoubleClick: () => handleDoubleClick(record,'helper'),
                        onClick: () => handleDoubleClick(record,'helper'),
                    };
                }}
                rowKey="key"
                pagination={false}
                search={false}
                options={false}
                toolBarRender={false}
            />
        );
    };

    const renderPanelTrigger = () =>{
        if(data[-1]){
            const items = data[-1].filter(item => item.field.startsWith(search));
            if(items.length > 0){
                const header = (<Text>Gatilho ({items && items.length})</Text>)
                return (<Panel key="trigger" header={header}>
                    {renderTable(items,-1,null)}
                </Panel>)
            }else return null

        }else return null

    }

    const renderPanelsHelpers = () => {
        return Object.entries(helpersDoc)
            .map(([key, section]) => {
                const items = Object.entries(section).filter(([keyFunction]) => keyFunction.startsWith(search))

                const hearder = (
                    <Text>
                        {key} ({items && items.length})
                    </Text>
                )

                if (items.length > 0) {
                    return (<Panel key={`helper-${key}`} header={hearder}>
                        {renderTableHelpers(items)}
                    </Panel>)
                }
                return null

            })
    }
    const renderTableCodeHelpers = (data) => (
        <ProTable
            columns={[
                { title: 'Nome', dataIndex: 'name', key: 'name' },
                { title: 'Descrição', dataIndex: 'description', key: 'description' },
                {
                    title: 'Expressão',
                    dataIndex: 'insert',
                    key: 'insert',
                    render: (text) => <Text code>{text}</Text>
                },
                {
                    title: 'Exemplo',
                    dataIndex: 'example',
                    key: 'example',
                    render: (text) => <Text type="secondary">{text}</Text>
                },
            ]}
            dataSource={data}
            onRow={(record) => {
                return {
                    style: { cursor: 'pointer' },
                    onDoubleClick: () => insertCodeHelper && insertCodeHelper(record),
                    onClick: () => insertCodeHelper && insertCodeHelper(record),
                };
            }}
            rowKey="insert"
            pagination={false}
            search={false}
            options={false}
            toolBarRender={false}
        />
    );

    // Busca por trecho, e não por prefixo como nas anotações: aqui o que o
    // usuário tem em mente é o efeito ("data", "somar"), não o começo do nome
    // da função.
    const renderPanelsCodeHelpers = () => {
        const term = search.trim().toLowerCase();
        return Object.entries(codeHelpersDoc)
            .map(([key, list]) => {
                const items = list.filter(item => !term ||
                    `${item.name} ${item.description} ${item.insert}`.toLowerCase().includes(term));

                if (items.length === 0) return null;

                const header = (<Text>{key} ({items.length})</Text>)
                return (
                    <Panel key={`code-${key}`} header={header}>
                        {renderTableCodeHelpers(items)}
                    </Panel>
                )
            })
    }

    /**
     * Se o resultado do passo `target` com certeza existe quando este passo
     * roda: os do tronco, os da própria rota e os de uma rota ancestral. Os de
     * outra rota — o caso típico é a etapa depois do desvio usando o que foi
     * calculado dentro de um caminho — continuam listados, mas marcados: se
     * aquele caminho não for percorrido, a etapa não executa e a referência
     * traz `skipped: true` no lugar do resultado. Mesma regra que o backend
     * aplica ao salvar, também como aviso
     * (save-actions-from-automations.use-case.ts).
     */
    const currentBranch = actions[actionStep] ? (actions[actionStep].branch ?? null) : null;
    const isAlwaysAvailable = (target) => {
        const targetBranch = target ? (target.branch ?? null) : null;
        if (!targetBranch) return true;
        if (targetBranch === currentBranch) return true;
        return !!currentBranch && currentBranch.startsWith(`${targetBranch}.`);
    };

    let panels = [];
    let conditionalSteps = 0;

    // Só etapas anteriores entram: uma etapa não pode usar o resultado de si
    // mesma nem de uma posterior, que ainda não executou.
    for (let i = 0; i < actionStep; i++) {
        // Guarda defensiva: passo recém-inserido pode ainda não ter snippets.
        const items = (data[i] ?? []).filter(item => item.field.startsWith(search) && !!!item.propFromLoop);
        if(items && items.length > 0){
            const conditional = !isAlwaysAvailable(actions[i]);
            if(conditional){
                conditionalSteps++;
            }
            const header = (
                <Text>
                    {getNameFromAction(actions[i])} ({items && items.length})
                    {conditional && (
                        <Text type="secondary">
                            {" "}— caminho {getBranchLabel(actions, actions[i].branch)}
                        </Text>
                    )}
                </Text>
            )
            panels.push(
                <Panel key={`step-${i}`} header={header}>
                    {renderTable(items,i,actions[i])}
                </Panel>
            )
        }
    }

    const currentHasLoop = !!(
        actions[actionStep] &&
        actions[actionStep].config &&
        actions[actionStep].config.loopData &&
        actions[actionStep].config.loopData.active
    );

    if( currentHasLoop && acceptEntryLoop ){
        const items = data[actionStep] ? data[actionStep].filter(item => item.field.startsWith(search) && (!!item.propFromLoop)) : [];
        const header = (<Text>{getNameFromAction(actions[actionStep])} ({items && items.length})</Text>)
        panels.push(
            <Panel key={`loop-${actionStep}`} header={header}>
                {renderTable(items,actionStep,actions[actionStep])}
            </Panel>
        )
    }
    panels  = [
        renderPanelTrigger(),
        ...panels,
        ...(isCode ? renderPanelsCodeHelpers() : renderPanelsHelpers())
    ]


    return (
        <React.Fragment>
            <Input prefix={<SearchOutlined/>}
                   allowClear
                   placeholder={"Pesquise por anotações disponíveis"}
                   onChange={(e) => setSearch(e.target.value)}>
            </Input>
            {isCode && (
                <div className="ae-hint" style={{marginTop: 8}}>
                    Este campo é avaliado como JavaScript: os auxiliares <Text code>{"{{ }}"}</Text> não
                    valem aqui. Estão disponíveis o JavaScript padrão e o <Text code>moment</Text>.
                    Ao inserir uma expressão, <Text code>VALOR</Text> fica selecionado, clique numa
                    anotação para colocá-la no lugar.
                </div>
            )}
            {currentHasLoop && !acceptEntryLoop && (
                <div className="ae-hint" style={{marginTop: 8}}>
                    {getNameFromAction(actions[actionStep])} não é listado aqui — este campo
                    é avaliado antes do laço começar, então o item da repetição ainda não existe.
                </div>
            )}
            {conditionalSteps > 0 && (
                <div className="ae-hint" style={{marginTop: 8}}>
                    {conditionalSteps === 1
                        ? "1 passo listado está dentro de um caminho do desvio"
                        : `${conditionalSteps} passos listados estão dentro de caminhos do desvio`}
                    {". Se a automação não seguir por lá, a etapa não executa e o resultado vem vazio."}
                    {" A anotação "}<Text code>skipped</Text>{" desses passos diz se o caminho foi percorrido."}
                </div>
            )}
            <Divider/>
            <Collapse ghost >
                {panels}
            </Collapse>
        </React.Fragment>
    );
};

const mapStateToProps = ({automation}) => ({
    actions: automation.actions,
    actionStep: automation.actionStep,
    trigger: automation.trigger,
    snippets: automation.snippets
});

export default connect(mapStateToProps,null)(SnippetSections)
